export default {
  "nav.spreadsheet": "Spreadsheet",
  "nav.finds": "Finds",
  "nav.guides": "Guias",
  "nav.review": "Review",
  "nav.shipping": "Envio",
  "nav.comparisons": "Comparativos",
  "nav.safety": "Segurança",
  "nav.blog": "Blog",
  "nav.cta": "Explorar Spreadsheet",
  "nav.home": "Início",
  "nav.shoppingGuide": "Guia de Compras",

  "hero.h1": "CSSBuy Spreadsheet",
  "hero.subtitle": "Encontre os melhores produtos e recursos da CSSBuy em um só lugar. Explore CSSBuy spreadsheets organizadas, produtos, vendedores, guias de QC, informações de envio e recursos atualizados para facilitar suas compras.",
  "hero.cta.primary": "Explorar CSSBuy Spreadsheet",
  "hero.cta.secondary": "Ver CSSBuy Finds",
  "hero.trust1": "Listas organizadas de produtos",
  "hero.trust2": "Guias para iniciantes",
  "hero.trust3": "Informações de envio",
  "hero.trust4": "Guias de QC",
  "hero.trust5": "Recursos de vendedores",
  "hero.trust6": "Conteúdo atualizado",

  "categories.title": "Encontre Produtos por Categoria",
  "categories.subtitle": "Navegue pelas nossas categorias curadas e descubra os melhores finds na CSSBuy.",
  "categories.cta": "Explorar Todas as Categorias",

  "cat.shoes": "Tênis",
  "cat.hoodies": "Moletom / Suéter",
  "cat.tshirts": "Camisetas",
  "cat.jackets": "Jaquetas",
  "cat.pants": "Calças / Shorts",
  "cat.headwear": "Bonés / Gorros",
  "cat.sets": "Conjuntos",
  "cat.underwear": "Roupa Íntima / Cueca",
  "cat.jersey": "Jersey",
  "cat.accessories": "Acessórios",
  "cat.bags": "Bolsas",
  "cat.belts": "Cintos",
  "cat.perfumes": "Perfumes",
  "cat.other": "Outros Itens",

  "featured.spreadsheet.title": "CSSBuy Spreadsheet Atualizada",
  "featured.spreadsheet.desc": "Encontre produtos, categorias e informações úteis organizadas em uma CSSBuy Spreadsheet simples de pesquisar e comparar.",
  "featured.spreadsheet.cta": "Ver Spreadsheet Completa",

  "featured.review.title": "CSSBuy Review",
  "featured.review.desc": "Quer entender melhor como a CSSBuy funciona? Consulte nosso guia sobre recursos, vantagens, limitações, envio, armazenamento e pontos importantes antes de comprar.",
  "featured.review.cta": "Ler CSSBuy Review",

  "featured.shipping.title": "CSSBuy Shipping Cost",
  "featured.shipping.desc": "Os custos de envio podem variar de acordo com destino, peso, volume, transportadora e método escolhido. Consulte nosso guia completo.",
  "featured.shipping.cta": "Ver Guia de Shipping Cost",

  "featured.coupon.title": "CSSBuy Coupon & Discount Code",
  "featured.coupon.desc": "Confira informações sobre cupons, promoções e códigos de desconto disponíveis. Verifique sempre validade e condições.",
  "featured.coupon.cta": "Ver Ofertas",

  "featured.warehouse.title": "CSSBuy Warehouse",
  "featured.warehouse.desc": "Entenda como funciona o armazenamento, QC, pedidos e preparação para envio.",
  "featured.warehouse.cta": "Ver Guia do Warehouse",

  "featured.safety.title": "Comprar com Mais Segurança",
  "featured.safety.desc": "Verifique links, vendedores, produtos, pagamentos e condições de envio antes de comprar.",
  "featured.safety.cta": "Ler Guia de Segurança",

  "articles.title": "Mais Guias de Compra",
  "articles.subtitle": "Explore nossa biblioteca de guias CSSBuy aprofundados cobrindo cada etapa da sua jornada de compra.",
  "articles.readMore": "Ler Guia",

  "faq.title": "Perguntas Frequentes",
  "faq.q1": "O que é CSSBuy Spreadsheet?",
  "faq.a1": "CSSBuy Spreadsheet é uma coleção organizada de product finds, informações de vendedores e recursos de compra para ajudar você a navegar na CSSBuy com mais eficiência. Inclui listas curadas de produtos, filtros por categoria e informações atualizadas para tornar sua experiência de compra mais fluida.",
  "faq.q2": "Como usar CSSBuy Spreadsheet?",
  "faq.a2": "Você pode navegar pela spreadsheet por categoria, pesquisar produtos específicos, verificar avaliações de vendedores e comparar opções. Cada entrada inclui detalhes do produto, informações do vendedor e links diretos para compra. Recomendamos verificar todas as informações antes de comprar.",
  "faq.q3": "A CSSBuy é confiável?",
  "faq.a3": "CSSBuy é um agente de compras conhecido que opera há vários anos. No entanto, como em qualquer plataforma de compras online, é importante verificar vendedores, checar fotos de QC e entender as políticas de envio antes de fazer compras. Este site fornece guias independentes para ajudar você a comprar com segurança.",
  "faq.q4": "A CSSBuy é segura?",
  "faq.a4": "A segurança depende de como você usa a plataforma. Sempre verifique a reputação do vendedor, cheque fotos de QC (quality control) antes do envio, use métodos de pagamento seguros e entenda a política de reembolso. Nosso Guia de Segurança fornece dicas detalhadas para compras seguras.",
  "faq.q5": "Quanto custa o envio da CSSBuy?",
  "faq.a5": "Os custos de envio variam de acordo com o país de destino, peso da encomenda, dimensões, transportadora e método escolhido. A CSSBuy oferece múltiplas linhas de envio com diferentes opções de velocidade e custo. Consulte nosso Guia de Shipping Cost para detalhes completos.",
  "faq.q6": "A CSSBuy oferece cupons?",
  "faq.a6": "A CSSBuy ocasionalmente oferece cupons e códigos promocionais. A disponibilidade e condições mudam ao longo do tempo. Sempre verifique as ofertas atuais diretamente na plataforma e consulte nosso Guia de Cupons para as informações mais recentes.",
  "faq.q7": "Como funciona o warehouse da CSSBuy?",
  "faq.a7": "O warehouse da CSSBuy recebe seus pedidos dos vendedores, armazena, realiza verificações de qualidade (QC) e prepara pacotes para envio internacional. Você pode solicitar fotos, combinar múltiplos itens e escolher métodos de envio pelo warehouse.",
  "faq.q8": "Iniciantes podem usar a CSSBuy?",
  "faq.a8": "Sim, iniciantes podem usar a CSSBuy, mas há uma curva de aprendizado. Recomendamos começar com nosso Guia para Iniciantes, entender como funcionam o warehouse e o processo de QC, e fazer pedidos de teste menores antes de compras maiores.",

  "newsletter.title": "Fique Atualizado",
  "newsletter.subtitle": "Receba as últimas atualizações da CSSBuy Spreadsheet, product finds e guias de compra no seu email.",
  "newsletter.placeholder": "Digite seu endereço de email",
  "newsletter.button": "Inscrever-se",
  "newsletter.privacy": "Respeitamos sua privacidade. Cancele a inscrição a qualquer momento.",
  "newsletter.success": "Obrigado por se inscrever!",
  "newsletter.error": "Por favor, insira um email válido.",

  "cta.main.title": "Pronto para encontrar seu próximo produto?",
  "cta.main.subtitle": "Explore nossa CSSBuy Spreadsheet, encontre produtos e consulte nossos principais guias antes de continuar sua jornada.",
  "cta.main.primary": "Explorar CSSBuy Spreadsheet",
  "cta.main.secondary": "Visitar o Site Principal",

  "footer.spreadsheet": "CSSBuy Spreadsheet",
  "footer.desc": "Um hub de recursos independente para usuários da CSSBuy. Não afiliado ou endossado pela CSSBuy.",
  "footer.links.title": "Links Rápidos",
  "footer.links.spreadsheet": "Spreadsheet",
  "footer.links.finds": "Finds",
  "footer.links.review": "Review",
  "footer.links.shipping": "Envio",
  "footer.links.coupon": "Cupons",
  "footer.links.safety": "Segurança",
  "footer.links.blog": "Blog",
  "footer.resources.title": "Recursos",
  "footer.resources.guides": "Guias de Compra",
  "footer.resources.qc": "Guia de QC",
  "footer.resources.sellers": "Guia de Vendedores",
  "footer.resources.comparisons": "Comparativos",
  "footer.legal.title": "Legal",
  "footer.legal.about": "Sobre",
  "footer.legal.policy": "Política Editorial",
  "footer.legal.contact": "Contato",
  "footer.disclaimer": "Este site é um recurso informativo independente e não é afiliado ou endossado pela CSSBuy.",
  "footer.copyright": "© 2026 CSSBuy Spreadsheet. Todos os direitos reservados.",

  "lang.en": "English",
  "lang.pt": "Português",
  "lang.de": "Deutsch",

  "dropdown.label": "Todas as Categorias",
  "dropdown.placeholder": "Escolha uma categoria...",

  "disclaimer": "Este site é um recurso informativo independente e não é afiliado ou endossado pela CSSBuy.",

  "article.published": "Publicado",
  "article.updated": "Atualizado",
  "article.readingTime": "min de leitura",
  "article.author": "Equipe Editorial",
  "article.sources": "Fontes",
  "article.cta": "Explorar CSSBuy Spreadsheet",
  "article.ctaSecondary": "Visitar Site Principal",
  "article.related": "Artigos Relacionados",
  "article.breadcrumb.home": "Início",
  "article.breadcrumb.blog": "Blog",
  "article.tableOfContents": "Índice",
  "article.share": "Compartilhar este artigo",
  "article.reportError": "Reportar Erro",
  "article.lastReviewed": "Última Revisão"
};